var React = require('react');

function Tiktok (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"d":"m12,0C5.37,0,0,5.37,0,12s5.37,12,12,12,12-5.37,12-12S18.63,0,12,0Zm5.57,10.8c-1.2,0-2.31-.38-3.21-1.03v4.7c0,2.35-1.91,4.26-4.25,4.26-1.23,0-2.33-.52-3.11-1.36-.71-.76-1.14-1.78-1.14-2.9,0-2.31,1.85-4.2,4.15-4.25.25,0,.49,0,.68.03v2.36c-.18-.06-.37-.09-.57-.09-1.07,0-1.94.87-1.94,1.94,0,1.34.92,1.94,1.94,1.94s1.9-.83,1.94-1.87V5.28h2.31c0,.81.3,1.54.79,2.11.45.52,1.06.89,1.75,1.04.22.05.44.07.67.07v2.31Z"})));
}

Tiktok.defaultProps = {"id":"Layer_2","data-name":"Layer 2","viewBox":"0 0 24 24"};

module.exports = Tiktok;

Tiktok.default = Tiktok;
